<template>
  <div>
    <nav-bar/>
    <div class="sidebar bg-darkgrey navbar-inverse side-box-shadow">
      <button id="addCustomer" class="btn btn-kne-orange col-12 mt-3" @click="add = true">
        <i class="fa fa-plus-circle fa-lg" aria-hidden="true"></i>
        {{$t('Users.sidebar.add')}}
      </button>
    </div>
    <div class="font-grey view">
      <div class="card">
        <paginate name="filterResults" tag="div" :list="filterResults" class="" :per="40">
        <div class="table-responsive">
          <table class="table table-hover mb-0 table-sm">
            <thead class="bg-darkgrey">
              <tr>
                <th @click="sortBy('firstName', false)" class="sortable nowrap">{{$t('Users.firstName')}}<i v-if="sort.current === 'firstName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('lastName', false)" class="sortable nowrap">{{$t('Users.lastName')}}<i v-if="sort.current === 'lastName'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('email', false)" class="sortable nowrap">{{$t('Users.email')}}<i v-if="sort.current === 'email'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('phoneNumber', false)" class="sortable nowrap">{{$t('Users.phone')}}<i v-if="sort.current === 'phoneNumber'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('role', false)" class="sortable nowrap">{{$t('Users.role')}}<i v-if="sort.current === 'role'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th @click="sortBy('password', false)" class="sortable nowrap">{{$t('Users.password')}}<i v-if="sort.current === 'password'" class="ml-1 fa" :class="{'fa-arrow-down': sort.desc, 'fa-arrow-up': !sort.desc}" aria-hidden="true"></i></th>
                <th></th>
              </tr>
            </thead>
            <transition-group name="fade" tag="tbody">
              <tr key='filter'>
                <td>
                  <regular-input
                    :value="fields.firstName"
                    @input="fields.firstName = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.firstName')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.lastName"
                    @input="fields.lastName = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.lastName')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.email"
                    @input="fields.email = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.email')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.phoneNumber"
                    @input="fields.phoneNumber = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.phone')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.role"
                    @input="fields.role = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.role')"/>
                </td>
                <td>
                  <regular-input
                    :value="fields.password"
                    @input="fields.password = $event; filteredSearchMethod()"
                    :placeholder="$t('Users.password')"/>
                </td>
                <th></th>
              </tr>
              <tr v-for="user in paginated('filterResults')" :key="user['.key']">
                <td class="nowrap"><p class="table-fix-width">{{user.firstName}}</p></td>
                <td>{{user.lastName}}</td>
                <td class="nowrap"><p class="table-fix-width">{{user.email}}</p></td>
                <td>{{user.phoneNumber}}</td>
                <td>{{user.role}}</td>
                <td>{{user.password}}</td>
                <td>
                  <input @click.prevent="modifying(user)" type="button" class="btn btn-kne-orange pull-right" :value="$t('Users.modify')">
                </td>
              </tr>
            </transition-group>
          </table>
        </div>
        </paginate>
        <paginate-links for="filterResults" :hide-single-page="true" :limit="5"></paginate-links>
      </div>
    </div>

    <transition name="fade">
      <modal v-if="add || modify" @close-request="add = false; modify = false; clear()" closable>
        <h4 v-if="add" class="kne-title mx-3">{{$t('Users.addTitle')}}</h4>
        <h4 v-else class="kne-title mx-3">{{$t('Users.modifyTitle')}}</h4>
        <div class="">
          <regular-input
          :value="user.firstName"
          @input="user.firstName = $event"
          type="text" :placeholder="$t('Users.firstName') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="user.lastName"
          @input="user.lastName = $event"
          type="text" :placeholder="$t('Users.lastName') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="user.phoneNumber"
          @input="user.phoneNumber = $event"
          type="text" :placeholder="$t('Users.phone') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="user.email"
          @input="user.email = $event"
          type="text" :placeholder="$t('Users.email') + '*'" class="col-12 form-group"/>
          <regular-input
          :value="user.password"
          @input="user.password = $event"
          type="text" :placeholder="$t('Users.password') + '*'" class="col-12 form-group"/>
          <regular-select
          :value="user.role"
          @change="user.role = $event"
          :disabled="modify && !isAdmin && user.role === 'Administrateur'"
          :placeholder="$t('Users.role') + '*'" class="col-12 form-group">
            <option :disabled="!isAdmin" value="Administrateur">{{ $t('Users.admin') }}</option>
            <option value="Chauffeur">{{ $t('Users.driver') }}</option>
            <option value="Dispatch">{{ $t('Users.dispatch') }}</option>
            <option value="Sous-traitant">{{ $t('Users.subcontractor') }}</option>
            <option value="Autre">{{ $t('Users.other') }}</option>
          </regular-select>
        </div>
        <div class="col-12">
          <button v-if="add" class="btn btn-kne-orange w-100" :disabled="!userFormCompleted" @click="addUser()">{{$t('Users.addUser')}}</button>
          <button v-else class="btn btn-kne-orange w-100" :disabled="!userFormCompleted" @click="modifyUser()">{{$t('Users.modifyUser')}}</button>
        </div>
        <h4 v-if="modify && isAdmin" class="kne-title mx-3 mt-3">{{$t('Users.deleteTitle')}}</h4>
        <div class="col-12">
          <button v-if="modify && isAdmin" class="btn btn-danger w-100" @click="deleteUser()">{{$t('Users.deleteUser')}}</button>
        </div>
      </modal>
    </transition>
  </div>
</template>

<script>
import Modal from '../Modal.vue'
import regularInput from '../regularInput.vue'
import regularCheckbox from '../regularCheckbox.vue'
import regularTextarea from '../regularTextarea.vue'
import regularSelect from '../regularSelect.vue'
import Search from '../module/Search.vue'
import {db} from '../../firebase'
import _ from 'lodash'

export default {
  name: 'Users',
  components: {
    Modal,
    regularInput,
    regularCheckbox,
    regularTextarea,
    regularSelect,
    Search
  },
  data () {
    return {
      add: false,
      modify: false,
      search: false,
      key: '',
      user: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        role: '',
        email: '',
        password: ''
      },
      provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
      fields: {
        firebase: '',
        lastName: '',
        phone: '',
        role: '',
        email: '',
        password: ''
      },
      filterResults: [],
      users: [],
      paginate: ['filterResults'],
      sort: {
        current: '',
        desc: true
      }
    }
  },
  computed: {
    userFormCompleted: function () {
      if (
        this.user.firstName !== '' &&
        this.user.lastName !== '' &&
        this.user.phoneNumber !== '' &&
        this.user.role !== '' &&
        this.user.email !== '' &&
        this.user.password !== '') return true
      else return false
    },
    uid () {
      return this.$store.state.user.uid
    },
    companyUID () {
      return this.$store.state.authorization.company
    },
    isAdmin () {
      return this.$store.state.authorization.role === 'Admin'
    }
  },
  methods: {
    filteredSearchMethod: _.debounce(function () {
      this.filterResults = []
      this.filterResults = this.users.filter((entry) => {
        var result = true
        for (var attr in this.fields) {
          if (this.fields[attr] !== '') {
            var reg = this.fields[attr].replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&')
            var re = new RegExp(reg, 'i')
            if (attr === 'creationDate') {
              let date = this.getDate(entry[attr])
              result = re.test(date)
            } else {
              result = re.test(entry[attr])
            }
          }
          if (result === false) break
        }
        return result
      })
      this.filterResults.reverse()
      this.sortBy(this.sort.current, true)
    }, 100),
    addUser: function () {
      window.axios.get('https://dev.transport.keepneye.com/infobemaster/decode/auth/' + this.user.email + '/' + this.user.password).then((response) => {
        db.ref('database/transporter/' + this.companyUID + '/user/employees').child(response.data.uid).child('infos').set(this.user)
        db.ref('users/deliverman').child(response.data.uid).set(this.companyUID)
        db.ref('database/transporter/' + this.companyUID + '/liste').child(response.data.uid).set(this.user.firstName + ' ' + this.user.lastName)
        if (this.user.role === 'Dispatch') {
          db.ref('users/transportersman').child(response.data.uid).set({'company': this.companyUID, 'role': 'Utilisateurs'})
        }
        // ======================== ADD CREATED USER LOG =======================
        this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'ADD_USER', 'createdUserUID': response.data.uid, 'date': Date.now(), 'createdUserName': this.user.firstName + ' ' + this.user.lastName})
        // ======================== ADD CREATED USER LOG =======================
        this.clear()
        this.add = !this.add
      }).catch((error) => console.log(error))
    },
    modifyUser: function () {
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key + '/infos').update(this.user)
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).set(this.user.firstName + ' ' + this.user.lastName)
      if (this.user.role === 'Dispatch') {
        db.ref('users/transportersman').child(this.key).update({'company': this.companyUID, 'role': 'Utilisateurs'})
      } else if (this.user.role === 'Administrateur') {
        db.ref('users/transportersman').child(this.key).update({'company': this.companyUID, 'role': 'Admin'})
      } else {
        db.ref('users/transportersman').child(this.key).remove()
      }
      // ======================== ADD MODIFY USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'MODIFY_USER', 'modifiedUserUID': this.key, 'date': Date.now(), 'modifiedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD MODIFY USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },
    deleteUser: function () {
      db.ref('database/transporter/' + this.companyUID + '/user/employees/' + this.key).remove()
      db.ref('database/transporter/' + this.companyUID + '/liste/' + this.key).remove()
      db.ref('users/deliverman').child(this.key).remove()
      db.ref('users/transportersman').child(this.key).remove()
      // ======================== ADD DELETED USER LOG =======================
      this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'DELETE_USER', 'deletedUserUID': this.key, 'date': Date.now(), 'deletedUserName': this.user.firstName + ' ' + this.user.lastName})
      // ======================== ADD DELETED USER LOG =======================
      this.modify = !this.modify
      this.clear()
    },
    modifying: function (user) {
      this.modify = true
      for (var attr in this.user) {
        this.user[attr] = user[attr]
        if (user[attr] === undefined) this.user[attr] = ''
      }
      this.key = user['.key']
    },
    clear: function () {
      for (var attr in this.user) {
        this.user[attr] = ''
      }
    },
    sortBy (criteria, newEntry) {
      if (this.sort.current === criteria && !newEntry) {
        this.sort.desc = !this.sort.desc
      } else if (!newEntry) {
        this.sort.desc = true
        this.sort.current = criteria
      }
      this.filterResults.sort((a, b) => {
        if (a[criteria] === undefined) a[criteria] = ''
        if (b[criteria] === undefined) b[criteria] = ''
        var A = a[criteria]
        var B = b[criteria]
        if (criteria !== 'creationDate') {
          A = a[criteria].toUpperCase() // ignore upper and lowercase
          B = b[criteria].toUpperCase() // ignore upper and lowercase
        }
        if (!this.sort.desc) {
          if (A < B) {
            return -1
          }
          if (A > B) {
            return 1
          }
        } else {
          if (A > B) {
            return -1
          }
          if (A < B) {
            return 1
          }
        }
        // names must be equal
        return 0
      })
    }
  },
  created () {
    this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID), null, () => {
      this.filteredSearchMethod()
    })
  },
  watch: {
    users: function () {
      this.filteredSearchMethod()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// Users.vue?621134a0